module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapping"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("亲爱的" + _vm._s(_vm.name) + "：您好！")]), _vm._v(" "), _c('p', [_vm._v("锦欣生殖男科已成立18周年，现荣获首批【中国男科十佳品牌科室】。我科致力于关注两性健康，在父亲节来临之际，特推出“包皮环切整形术”优惠活动，我院采用一次性环切器进行手术，具有手术时间短、切口美观、愈合快的优点。")]), _vm._v(" "), _c('h4', [_vm._v("1、活动时间：")]), _vm._v(" "), _c('p', [_vm._v("①活动报名截止时间：2018年6月30日前完成预约登记")]), _vm._v(" "), _c('p', [_vm._v("②手术时间：2018年12月31日前完成手术")]), _vm._v(" "), _c('h4', [_vm._v("2、预约登记方式：")]), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "color": "rgb(255, 104, 39)",
      "font-weight": "bold"
    },
    on: {
      "click": _vm.look
    }
  }, [_vm._v("①戳这里，立即在线预约")])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('p', [_vm._v("③来院现场预约")]), _vm._v(" "), _c('h4', [_vm._v("3、就诊流程")]), _vm._v(" "), _c('p', [_vm._v(" 预约成功后（收到就诊短信）——前台办卡/挂号（出示就诊短信） ——到 男科特诊室 就诊。")]), _vm._v(" "), _vm._m(1, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("②拨打"), _c('a', {
    staticStyle: {
      "color": "rgb(255, 104, 39)",
      "font-weight": "bold"
    },
    attrs: {
      "href": "tel:02782889968"
    }
  }, [_vm._v("027-82889968（点击拨打）")]), _vm._v("，进行电话预约")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("原文链接："), _c('a', {
    staticStyle: {
      "color": "rgb(255, 104, 39)",
      "font-weight": "bold"
    },
    attrs: {
      "href": "https://mp.weixin.qq.com/s?__biz=MzA5MTY0MDczMg==&tempkey=OTYxX1Q1THE5K3NpVnhscFVIbEtJSkdTS0FBOHk1bndseFdraWZOWEpHSzV5cWwybVRyTVd2VldLYVB6Mm1WZU11cEJpcWtCNXQ4MV9TYUtnb2RsSmt4Y2x1OHVNWGZ3YllpbmFUN2trd2piUy02alVRQ0l3VDgxQnY2aG9TaDV4OVFjME5MNWZjLTFaNmtmN1hqWGVXTzN1bThXaW1UNmV0ODREaVVwUVF%2Bfg%3D%3D&chksm=0b85e02b3cf2693d2916d34c590f60081ec3254ab750ac1caa268610b0a49c302a83abfec73c&mpshare=1&scene=1&srcid=0615azUd6BCVgye1zyGJrYct#rd"
    }
  }, [_vm._v("包皮过长，到底该不该切？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101629fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/articleProject/wrapping.vue
// module id = E7PY
// module chunks = 7